import { peekLoadedPlatformTimezone, subscribePlatformSession } from '../platform/platformSessionStore';

/**
 * Which IANA zone decides "today" inside a date picker (KAN-791). A tiny store with
 * NO app imports so a leaf like ResponsiveDateField never pulls auth / supabase into
 * a Jest tree. CompanySettingsProvider writes the company zone here; the platform
 * session store (loaded only for a super-admin) wins on platform surfaces.
 * Unknown -> null, and callers fall back to the device date.
 */
let tenantZone = null;
const listeners = new Set();

export function setCalendarTenantTimezone(tz) {
  const next = tz || null;
  if (next === tenantZone) return;
  tenantZone = next;
  [...listeners].forEach((fn) => { try { fn(); } catch (_) { /* never break a reader */ } });
}

export function subscribeCalendarZone(fn) {
  listeners.add(fn);
  const offPlatform = subscribePlatformSession(fn);
  return () => { listeners.delete(fn); offPlatform(); };
}

export function getCalendarTimezone() {
  return peekLoadedPlatformTimezone() || tenantZone;
}
